import { Component, ElementRef, AfterViewInit, ViewChild, Input, OnChanges, OnDestroy, SimpleChange, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import * as OT from '@opentok/client';
import { Room } from '../../../../models';
import { EnvironmentService } from '../../../../services/enviroment/environment.service';
import { UtilsService } from '../../../../services/utils/utils.service';
import { CameraComponent } from './components/camera/camera.component';
import { SpeakerComponent } from './components/speaker/speaker.component';
import { CapturePhotoComponent } from './components/capture-photo/capture-photo.component';

@Component({
  selector: 'sas-subscriber',
  standalone: true,
  imports: [CameraComponent,SpeakerComponent,CapturePhotoComponent],
  templateUrl: './subscriber.component.html',
  styleUrls: ['./subscriber.component.scss']
})
/**
 * Componente para el control de la pantalla de videoconferencia del participante.
 * Funciones:
 * - Adherirse a la sesión de videoconferencia
 * - Controlar barra de herramientas de microfono, audio y camara
 */
export class SubscriberComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('subscriberDiv') subscriberDiv?: ElementRef;
  @Input() session?: OT.Session;
  @Input() stream!: OT.Stream;
  @Input() subscriberAudio = true;
  @Input() roomData?: Room;
  public showCapturePhoto: boolean;
  audioActive = true;
  subscriber: any;
  blockAudio?: boolean;
  constructor(
    private readonly enviromentSvc: EnvironmentService,
    private readonly utilsService: UtilsService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
    // Según configuración del aplicativo habilita la captura de pantalla.
    this.showCapturePhoto = this.enviromentSvc.data.features.capture_photo;
  }

  /**
   * Se controla el cambio en la barra de herramientas del header de audio.
   * La barra de herramientas general del header tiene prioridad sobre las
   * barras de herramientas de los participantes.
   * @param ev
   */
  ngOnChanges(ev: SimpleChanges) {
    if (ev['subscriberAudio'] && typeof ev['subscriberAudio'].currentValue === 'boolean' && this.subscriber) {
      this.audioActive = this.subscriberAudio && this.stream.hasAudio ? true : false;
      console.log('Subscriber ngOnChanges subscriber.setAudioVolume (' + this.utilsService.getTodayWithHour() +') currentValue:', ev['subscriberAudio'].currentValue);
      this.subscriber.setAudioVolume(ev['subscriberAudio'].currentValue ? 100 : 0);
      this.changeDetectorRef.detectChanges();
    }
  }
  /**
   * Iniciamos a la subscripcion a la sessión para obtener los valores
   * de la videoconferencia del participante. volumen, micrófono y vídeo.
   */
  ngAfterViewInit() {
    if(!this.subscriberDiv) return;
    console.log('Subscriber this.session.subscribe ---->' + this.utilsService.getTodayWithHour());
    this.subscriber = this.session?.subscribe(this.stream, this.subscriberDiv.nativeElement, {
      width: '100%',
      height: '100%',
      fitMode: 'cover',
      insertMode: 'append',
      testNetwork: true,
      style: {
        audioLevelDisplayMode: 'on',
        buttonDisplayMode: 'off',
        nameDisplayMode: 'on'
      }
    }, (value) => {
      console.log('Subscriber this.session.subscribe callback---->' + this.utilsService.getTodayWithHour(), value);
      this.subscriber.setAudioVolume(this.subscriberAudio ? 100 : 0);
      this.changeDetectorRef.detectChanges();
    });

    if (this.subscriber?.id) {
      const id = this.subscriber.element.parentElement.id;
      (document.querySelector('#' + id + ' .display-control-container') as any)['style'].position = 'absolute';
      this.changeDetectorRef.detectChanges();
    }
  }

  //Eliminamos los eventos del subscriber
  ngOnDestroy(): void {
    this.subscriber.off();
    this.changeDetectorRef.detectChanges();
  }
}
